import palette from './palette';

const typography = {
    family: 'poppins, Arial, sans-serif',
    size: '14px',
    lineHeight: '18px',
    weightLight: 400,
    weightNormal: 500,
    weightBold: 600,
    colour: palette.primary.dark
};

typography.title = {
    size: '30px',
    weight: typography.weightBold,
    colour: typography.colour
};

typography.subtitle = {
    size: '16px',
    weight: typography.weightNormal,
    colour: palette.primary.main
};

typography.heading = {
    size: '25px',
    weight: typography.weightBold
};

typography.modalTitle = {
    size: '20px',
    weight: typography.weightNormal
};

typography.info = {
    size: '13px',
    weight: typography.weightNormal
};

export default typography;



// WEBPACK FOOTER //
// ./app/themes/default-theme/typography.js